module.exports = __webpack_public_path__ + "static/media/share-square-solid.d2300f52.svg";